import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface HitsErrorsControlProps {
  teamAHits: number;
  teamAErrors: number;
  teamBHits: number;
  teamBErrors: number;
  teamAName: string;
  teamBName: string;
  onTeamAHitsChange: (hits: number) => void;
  onTeamAErrorsChange: (errors: number) => void;
  onTeamBHitsChange: (hits: number) => void;
  onTeamBErrorsChange: (errors: number) => void;
}

export function HitsErrorsControl({
  teamAHits,
  teamAErrors,
  teamBHits,
  teamBErrors,
  teamAName,
  teamBName,
  onTeamAHitsChange,
  onTeamAErrorsChange,
  onTeamBHitsChange,
  onTeamBErrorsChange,
}: HitsErrorsControlProps) {
  return (
    <Card className="bg-[#1A1F2C]/80 backdrop-blur-sm border border-white/10">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-semibold text-white">Hits & Errors</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          {/* Away Team (Team A) */}
          <div>
            <h3 className="text-white font-medium mb-2">{teamAName}</h3>
            <div className="flex flex-col space-y-2">
              <div className="flex items-center space-x-2">
                <span className="text-white w-16">Hits:</span>
                <div className="flex items-center space-x-2">
                  <Button 
                    variant="outline" 
                    size="sm" 
                    onClick={() => onTeamAHitsChange(Math.max(0, teamAHits - 1))}
                    disabled={teamAHits <= 0}
                  >
                    -
                  </Button>
                  <span className="text-white w-8 text-center">{teamAHits}</span>
                  <Button 
                    variant="outline" 
                    size="sm" 
                    onClick={() => onTeamAHitsChange(teamAHits + 1)}
                  >
                    +
                  </Button>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-white w-16">Errors:</span>
                <div className="flex items-center space-x-2">
                  <Button 
                    variant="outline" 
                    size="sm" 
                    onClick={() => onTeamAErrorsChange(Math.max(0, teamAErrors - 1))}
                    disabled={teamAErrors <= 0}
                  >
                    -
                  </Button>
                  <span className="text-white w-8 text-center">{teamAErrors}</span>
                  <Button 
                    variant="outline" 
                    size="sm" 
                    onClick={() => onTeamAErrorsChange(teamAErrors + 1)}
                  >
                    +
                  </Button>
                </div>
              </div>
            </div>
          </div>
          
          {/* Home Team (Team B) */}
          <div>
            <h3 className="text-white font-medium mb-2">{teamBName}</h3>
            <div className="flex flex-col space-y-2">
              <div className="flex items-center space-x-2">
                <span className="text-white w-16">Hits:</span>
                <div className="flex items-center space-x-2">
                  <Button 
                    variant="outline" 
                    size="sm" 
                    onClick={() => onTeamBHitsChange(Math.max(0, teamBHits - 1))}
                    disabled={teamBHits <= 0}
                  >
                    -
                  </Button>
                  <span className="text-white w-8 text-center">{teamBHits}</span>
                  <Button 
                    variant="outline" 
                    size="sm" 
                    onClick={() => onTeamBHitsChange(teamBHits + 1)}
                  >
                    +
                  </Button>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-white w-16">Errors:</span>
                <div className="flex items-center space-x-2">
                  <Button 
                    variant="outline" 
                    size="sm" 
                    onClick={() => onTeamBErrorsChange(Math.max(0, teamBErrors - 1))}
                    disabled={teamBErrors <= 0}
                  >
                    -
                  </Button>
                  <span className="text-white w-8 text-center">{teamBErrors}</span>
                  <Button 
                    variant="outline" 
                    size="sm" 
                    onClick={() => onTeamBErrorsChange(teamBErrors + 1)}
                  >
                    +
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
} 